var cifBs = ["301 151", "<g fill='none'><path fill='#00ABC9' d='M.5.5h300v150H.5z'/><path fill='#FAE042' d='M.5 50.5h300v50H.5z'/><path fill='#000' d='M.5.5v150l125-75z'/></g>"];

export { cifBs };
//# sourceMappingURL=cif-bs.js.map
